import type { ReactNode } from 'react';
import { ChevronLeft } from '../../ui/icons';

/** Top bar with a labelled back chevron and an optional trailing slot (e.g. "Skip"). */
export function AuthHeader({
  backLabel,
  onBack,
  trailing
}: {
  backLabel?: string;
  onBack?: () => void;
  trailing?: ReactNode;
}) {
  return (
    <div className="flex h-12 items-center justify-between pt-2">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="tap -ml-2 flex items-center gap-1 pr-3 text-[15px] font-semibold text-ink active:opacity-60"
        >
          <ChevronLeft width={20} height={20} strokeWidth={2.2} />
          {backLabel}
        </button>
      ) : (
        <span />
      )}
      {trailing}
    </div>
  );
}
